import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Directive, HostBinding, HostListener, inject, signal } from '@angular/core';

@Directive({
    selector: '[tranDropdownTrigger]',
    exportAs: 'tranDropdownTrigger',
    hostDirectives: [CdkOverlayOrigin]
})
export class DropdownTriggerDirective {
    public readonly origin = inject(CdkOverlayOrigin);
    public readonly open = signal(false);

    @HostBinding('attr.aria-haspopup')
    protected readonly ariaHaspopup = 'listbox';

    @HostBinding('attr.aria-expanded')
    protected get ariaExpanded(): boolean {
        return this.open();
    }

    @HostBinding('class.show')
    protected get isShown(): boolean {
        return this.open();
    }

    @HostListener('click')
    protected toggle(): void {
        this.open.update(isOpen => !isOpen);
    }

    @HostListener('keydown', ['$event'])
    protected onKeydown(event: KeyboardEvent): void {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (!this.open()) {
                this.open.set(true);
            }
        } else if (event.key === 'Escape' && this.open()) {
            event.preventDefault();
            this.close();
        }
    }

    public close(): void {
        this.open.set(false);
        this.origin.elementRef.nativeElement.focus();
    }
}
